import React, { useState, useRef } from "react";
import Image from "../../assets/images/pass-logo.png";
import PrivacyModal from "../modal/PrivacyModal";
import TermsModal from "../modal/TermsModal";
import RefundModal from "../modal/RefundModal";
import axios from "axios";

const Footer = () => {
  const [modalShow1, setModalShow1] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const requestUrl = "/subscribe";
  const name = useRef();
  const email = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    const requestBody = {
      name: name.current.value,
      email: email.current.value,
    };

    axios
      .post(requestUrl, requestBody)
      .then((response) => {
        name.current.value = "";
        email.current.value = "";
      })
      .catch((error) => {
        
      });
  };

  return (
    // App footer section
    <div className="">
      <footer className="footer_section">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3 footer-col">
              <div className="footer_detail">
                <div className="footer_contact">
                  <h4>Reach us at..</h4>
                  <div className="contact_link_box">
                    <a href="">
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                      <span>Kubwa, FCT Abuja.</span>
                    </a>
                    <a href="tel:+2349035559352">
                      <i className="fa fa-phone" aria-hidden="true"></i>
                      <span>Call +234 9035559352</span>
                    </a>
                    <a href="mailto:info@payaftersalary.com?subject=Inquiry">
                      <i className="fa fa-envelope" aria-hidden="true"></i>
                      <span>info@payaftersalary.com</span>
                    </a>
                  </div>
                </div>
                <div className="footer_social">
                  <a href="https://web.facebook.com/Pay-After-Salary-System-101458861427503">
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                  <a href="https://twitter.com/SystemPay">
                    <i className="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/pay-after-salary-system-6129b6242">
                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.instagram.com/payaftersalarysystem5">
                    <i className="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 footer-col">
              <div className="footer_contact">
                <h4>Company</h4>
                <div className="contact_link_box">
                  <a href="/platforms">
                    <span>Our Platforms</span>
                  </a>
                  <a href="/about">
                    <span>About Us</span>
                  </a>
                  <a>
                    <button onClick={() => setModalShow1(true)}>
                      {" "}
                      <span style={{ color: "white" }}>Privacy Policy</span>
                    </button>

                    <PrivacyModal
                      show={modalShow1}
                      onHide={() => setModalShow1(false)}
                    />
                  </a>

                  <a>
                    <button onClick={() => setModalShow2(true)}>
                      {" "}
                      <span style={{ color: "white" }}>
                        Terms and Condition
                      </span>
                    </button>

                    <TermsModal
                      show={modalShow2}
                      onHide={() => setModalShow2(false)}
                    />
                  </a>
                  <a>
                    <button onClick={() => setModalShow3(true)}>
                      {" "}
                      <span style={{ color: "white" }}>
                        Refund Policy
                      </span>
                    </button>

                    <RefundModal
                      show={modalShow3}
                      onHide={() => setModalShow3(false)}
                    />
                  </a>

                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 footer-col">
              <div className="footer_contact">
                <h4>Vendors</h4>
                <div className="contact_link_box">
                  <a href="/sellers">
                    <span>Sellers</span>
                  </a>
                  <a href="/services">
                    <span>Services</span>
                  </a>
                  <a href="/properties">
                    <span>Properties</span>
                  </a>
                  <a href="/vendor-signin">
                    <span>Account</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 footer-col">
              <div className="footer_contact">
                <h4>Subscribe</h4>
                <form action={handleSubmit}>
                  <input type="text" placeholder="Enter your name" ref={name} />
                  <div style={{ height: "10px" }}></div>
                  <input
                    type="text"
                    placeholder="Enter your email"
                    ref={email}
                  />
                  <button type="submit">Subscribe</button>
                </form>
              </div>
            </div>
          </div>
          <div className="footer-info">
            <p>
              &copy; <span id="displayYear"></span> Copyright 2024{" "}
              <a href="/" style={{ color: "white", fontWeight: "500" }}>
                Pay After Salary System Limited
              </a>
              . All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
